module.exports = __webpack_public_path__ + "static/media/31-iveco.0e3a4856.jpg";